import { render } from "./Chapters.vue?vue&type=template&id=5452872a&scoped=true"
import script from "./Chapters.vue?vue&type=script&lang=js"
export * from "./Chapters.vue?vue&type=script&lang=js"

import "./Chapters.vue?vue&type=style&index=0&id=5452872a&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5452872a"]])

export default __exports__